import './Footer.scss';
import LogoSlider from '../LogoSlider/LogoSlider';

const Footer = () => {
	LogoSlider();
};

export default Footer;
